import React from 'react'
import {useToggle} from '@startlibs/core'
import { jwtGetFetcher } from '../utils/authFetch'
import {ShareDialog} from 'sharecomponents/src/pages/ShareDialog'
import {CaseRequestInfo} from '../components/CaseRequestInfo'
import {useNotificationRef} from '../components/Notifications'
import {getJwt} from './useJwt'

export const useShareDialog = (caseRequest,isAssociate) => {
  const shareDialog = useToggle()
  const shareToken = useToggle()
  const shareJwtLoading = useToggle()

  const [, setNotification] = useNotificationRef()

  const notifyAndClose = (notification,notificationType) => {
    shareToken.close()
    if (notificationType==='email') {
      setNotification("Report successfully shared.")
    } else {
      setNotification(notification)
    }
    shareDialog.close()
  }

  const openShareDialog = () => {
    shareDialog.open()
    if (!shareToken.isOpen) {
      shareJwtLoading.wait(
        jwtGetFetcher(getJwt())(`/api/system/jwt?requestId=${caseRequest.requestId}`)
          .then(({jwt}) => shareToken.openWith(jwt))
      )
    }
  }

  return [openShareDialog,shareDialog.isOpen &&
    <ShareDialog
      caseRequestInfo={<CaseRequestInfo sharing caseRequest={caseRequest}/>}
      caseRequest={caseRequest}
      suggestionLabel="Include patient: "
      suggestedEmails={(isAssociate && caseRequest.patientInfo.email) ? [caseRequest.patientInfo.email] : []}
      notifyAndClose={notifyAndClose}
      closeDialog={() => {shareDialog.close(); shareToken.close()}}
      jwt={shareToken.isOpen}
      evJwt={getJwt()}
    />]
}
